import React from "react";
import { motion } from "framer-motion";
import BlogsList from "./blogsList/BlogsList";

const Blogs = () => {
  return (
    <motion.div
      initial={
          {
              opacity: 0,
          }
      }
      animate={
          {
              opacity: 1,
          }
      }
      exit={
          {
              opacity: 0,
          }
      }
    >
      <BlogsList />
    </motion.div>
  );
};

export default Blogs;
